export { StylePrimarySmall } from "./StylePrimarySmall";
